import type { AlgoliaCity } from '~/composables/types/algolia'
import { useAlgoliaIndexNames } from '~/composables/algolia/useAlgoliaIndexNames'

export const useAlgoliaLocalities = async (
  initialCitySlug = '',
  immediate = true
) => {
  const searchQuery = ref('')
  const citySlug = ref(initialCitySlug)
  const defaultReqOpts = {
    similarQuery: '',
    clickAnalytics: true,
    hitsPerPage: 6,
  }
  const { localities: localitiesIndex } = useAlgoliaIndexNames()

  const { result: localitiesAlgolia, search } =
    useAlgoliaSearch<AlgoliaCity>(localitiesIndex)

  const { execute } = await useAsyncData(
    localitiesIndex,
    () => {
      return search({
        query: searchQuery.value,
        requestOptions: {
          ...defaultReqOpts,
          optionalFilters: [`slug:${citySlug.value}`],
          aroundLatLngViaIP:
            !citySlug.value && process.client && !searchQuery.value,
        },
      })
    },
    {
      immediate,
      deep: true,
      watch: [citySlug],
    }
  )

  async function searchLocalities(query: string) {
    searchQuery.value = query
    return await execute()
  }

  async function searchLocalitiesWithOptionalCityFilter(slug: string) {
    citySlug.value = slug
    return await execute()
  }

  return {
    localitiesAlgolia,
    setCitySlug: (citySlugVal: string) => {
      citySlug.value = citySlugVal
    },
    searchLocalities,
    searchLocalitiesWithOptionalCityFilter,
  }
}
